import React, { Component } from "react";
// import { Form,  message, Button, Icon } from 'antd';
import {Upload,message,Button,Icon} from "antd";
import UploadService from "../upload.service";
import { RcCustomRequestOptions } from "antd/lib/upload/interface";
const { Dragger } = Upload;
interface iProps {
  uploadSignURL?: string;
  fileType?: string;
  filePatten?: string;
  maxFileLength?: number;
  minFileLength?: number;
  action?: string;
  onChange?: (files: any[]) => void;
}
export default class SingleFileUpload extends Component<iProps> {
  private uploadService: UploadService = new UploadService();
  state: any = {
    OSSData: {},
    fileList: [],
  };
  transformFile = (file) => {
    const { OSSData } = this.state;
    const urlObj=new URL(OSSData.putSignUrl)
    file.url = `${urlObj.origin}${urlObj.pathname}`;
    file.fileUrl = `${urlObj.origin}${urlObj.pathname}`;
    file.uid = OSSData.fileId;
    file.newUploadFlag = true;
    return file;
  };
  // getExtraData = (file) => {
  //   const { OSSData } = this.state;
  //   return {
  //     key: `${OSSData.dir}/${OSSData.fileId}`,
  //     dir: OSSData.dir,
  //     OSSAccessKeyId: OSSData.accessid,
  //     policy: OSSData.policy,
  //     Signature: OSSData.signature,
  //   };
  // };
  onChange = ({ fileList, file, event }) => {
    const { onChange } = this.props;
    let files = [];
    if (file.status === "removed") {
      files = [];
    } else {
      files = [file];
    }
    this.setState({
      fileList: files,
    });
    if (onChange) {
      onChange(files);
    }
  };

  beforeUpload = (file): any => {
    let { maxFileLength = 4096, minFileLength = 0 } = this.props;
    const isLtMaxFileLength = file.size / 1024 / 1024 < maxFileLength;
    if (!isLtMaxFileLength) {
      message.warn(`单个文件体积不能大于${maxFileLength}MB`);
      return isLtMaxFileLength;
    }
    const isGtMaxFileLength = file.size / 1024 / 1024 > minFileLength;
    if (!isGtMaxFileLength) {
      message.warn(`单个文件体积不能小于${minFileLength}MB`);
      return isGtMaxFileLength;
    }
    return new Promise<void>(async (resolve, reject) => {
      try {
        let data = await this.uploadService.getExcelOssData(
          this.props.uploadSignURL
        );
        await this.setState({
          OSSData: data,
        });
        resolve();
      } catch (error) {
        reject();
      }
    });
  };
  customRequest=(options: RcCustomRequestOptions)=>{
    const {file,onProgress,onSuccess}=options
    const xhr = new XMLHttpRequest()
    xhr.upload.addEventListener('progress', (event) => {
        if (event.lengthComputable) {
            onProgress({ percent:event.loaded/event.total*100 },file)
        }
    })
    xhr.addEventListener('load', (event) => {
        // 文件上传完成
        console.log('文件上传完成', event)
        if (xhr.status === 200) {
          onSuccess(xhr.response,file )    
        }
    })
    xhr.addEventListener('error', (event) => {
        // 文件上传发生错误
        console.error('文件上传发生错误',event)
    })
    xhr.open('PUT', this.state.OSSData.putSignUrl)
    xhr.setRequestHeader('Content-Type', file.type);
    xhr.send(file)
  }
  render() {
    const { fileList } = this.state;
    return (
      <div className="upload">
        <Dragger
          accept=".xls,.xlsx"
          fileList={fileList}
          showUploadList={{
            showPreviewIcon: false,
            showRemoveIcon: true,
            showDownloadIcon: false,
          }}
          name="file"
          action={this.state.OSSData.host}
          onChange={this.onChange}
          transformFile={this.transformFile}
          // data={this.getExtraData}
          beforeUpload={this.beforeUpload}
          customRequest={this.customRequest}
        >
          <p className="ant-upload-drag-icon">
            <Icon type="inbox" />
          </p>
          <p className="ant-upload-text">点击或将文件拖拽到这里上传</p>
          <p className="ant-upload-hint">文件格式：xls、xlsx</p>
        </Dragger>
      </div>
    );
  }
}
